export enum LayerGroupClassification {
  ZONE = 'zone',
  WORK = 'work',
  PLAN = 'plan'
}
